import { createWithEqualityFn as create } from 'zustand/traditional';
import config from '../config';

interface VersionActions {
  setLatestClientVersion: (version: number) => void;
  acknowledgeRefresh: () => void;
}

export interface VersionState {
  currentClientVersion: number;
  latestClientVersion?: number;
  alreadyRefreshed: boolean;
  actions: VersionActions;
}

// Initialize hasRefreshed from sessionStorage
const STORAGE_KEY = `already-refreshed-v${config.release}`;
const initialRefreshed = typeof window !== 'undefined' && sessionStorage.getItem(STORAGE_KEY) === 'true';

export const useVersionStore = create<VersionState>()((set, get) => ({
  currentClientVersion: config.release,
  latestClientVersion: undefined,
  alreadyRefreshed: initialRefreshed,

  actions: {
    setLatestClientVersion: (version) => set({ latestClientVersion: version }),

    acknowledgeRefresh: () => {
      // mark as refreshed and persist in sessionStorage
      sessionStorage.setItem(STORAGE_KEY, 'true');
      set({ alreadyRefreshed: true });
    },
  },
}));

// We don't consider n-1 to be outdated, as this can happen during a deployment. Require n-5 before showing toast.
export const useOutdated = () =>
  useVersionStore((state) => {
    return state.latestClientVersion !== undefined && state.currentClientVersion + 4 < state.latestClientVersion;
  });
export const useLatestClientVersion = () => useVersionStore((state) => state.latestClientVersion);
export const useCurrentClientVersion = () => useVersionStore((state) => state.currentClientVersion);
export const useAlreadyRefreshed = () => useVersionStore((state) => state.alreadyRefreshed);

export const useVersionActions = () => useVersionStore((state) => state.actions);
